export default __webpack_public_path__ + "static/confete-64c1eb607bc17c51a00ea98eb8a50e72.svg";